import {
  select, call, put, takeEvery,
} from 'redux-saga/effects';
import api from 'linkia-api';

import {
  LIST,
  GET,
  UPDATE,
  REMOVE,
  CREATE,
} from './action-types';
import {
  list,
  reset,
  requestFailed,
  listSucceeded,
  getSucceeded,
  updateSucceeded,
  removeSucceeded,
  createSucceeded,
} from './actions';

import { tokenSelector } from '../login/selectors';

function* listModuleSemesters() {
  const token = yield select(tokenSelector);
  try {
    const data = yield call(api.moduleSemester.listModuleSemester, { token });
    yield put(listSucceeded(data));
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* getModuleSemester(action) {
  const token = yield select(tokenSelector);
  const { id } = action;
  try {
    const data = yield call(api.moduleSemester.get, { token, id });
    yield put(getSucceeded(data));
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* updateModuleSemester(action) {
  const token = yield select(tokenSelector);
  const { id, data } = action;
  try {
    const success = yield call(api.moduleSemester.update, { token, id, data });
    yield put(updateSucceeded(success));
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* removeModuleSemester(action) {
  const token = yield select(tokenSelector);
  const { id } = action;
  try {
    const success = yield call(api.moduleSemester.delete, { token, id });
    yield put(removeSucceeded(success));
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

function* createModuleSemester(action) {
  const token = yield select(tokenSelector);
  const { data } = action;
  try {
    const success = yield call(api.moduleSemester.create, { token, data });
    yield put(createSucceeded(success));
    yield put(reset());
    yield put(list());
  } catch (e) {
    yield put(requestFailed(e));
  }
}

export default [
  takeEvery(LIST, listModuleSemesters),
  takeEvery(GET, getModuleSemester),
  takeEvery(UPDATE, updateModuleSemester),
  takeEvery(REMOVE, removeModuleSemester),
  takeEvery(CREATE, createModuleSemester),
];
